// extracted by mini-css-extract-plugin
export default {"field":"Switch_field__kKkDq","justify":"Switch_justify__J4Sfw","disabled":"Switch_disabled__lIxE2","slider":"Switch_slider__9RpR2","round":"Switch_round__RYRQq"};